import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { fetchCourse } from "@/lib/aiot";
import { Hero } from "@/components/aiot/Hero";
import { Overview, Highlights, DemoStrip, Curriculum, WeeklyFormat, Assessment, Tools, Careers } from "@/components/aiot/LandingSections";
import { Instructor, Faq, ApplySection } from "@/components/aiot/LandingExtras";

const NAV = [["overview", "Overview", "ओवरव्यू"], ["highlights", "Highlights", "ख़ास बातें"], ["demos", "Sample classes", "सैंपल क्लास"], ["curriculum", "Curriculum", "पाठ्यक्रम"],
  ["format", "Weekly format", "साप्ताहिक फ़ॉर्मेट"], ["assessment", "Assessment", "मूल्यांकन"], ["instructor", "Instructor", "इंस्ट्रक्टर"], ["tools", "Tools", "टूल्स"], ["careers", "Careers", "करियर"], ["faq", "FAQ", "FAQ"]];

const SubNav = () => {
  const { L } = useLang();
  return (
    <nav className="sticky top-16 z-30 bg-white/85 backdrop-blur-xl border-y border-slate-200" data-testid="aiot-subnav">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center gap-2 h-12">
        <div className="flex-1 flex gap-1 overflow-x-auto no-scrollbar">
          {NAV.map(([id, en, hi]) => (
            <a key={id} href={`#${id}`} className="shrink-0 px-3 py-1.5 rounded-full text-sm font-semibold text-slate-600 hover:text-[#0F766E] hover:bg-[#F0FDFA] transition-colors" data-testid={`aiot-subnav-${id}`}>{L(en, hi)}</a>
          ))}
        </div>
        <a href="#apply" className="shrink-0 rounded-full bg-[#0F766E] text-white px-4 h-9 inline-flex items-center text-sm font-bold hover:bg-[#0B1F3A] transition-colors" data-testid="aiot-subnav-apply">{L("Apply", "आवेदन")}</a>
      </div>
    </nav>
  );
};

// Router links with a hash (e.g. Enroll -> #apply) don't scroll by themselves; retry until the section has rendered.
const useHashScroll = () => {
  const { hash, key } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    let tries = 0;
    const id = setInterval(() => {
      const el = document.getElementById(hash.slice(1));
      if (el || ++tries > 20) { clearInterval(id); el?.scrollIntoView({ behavior: "smooth" }); }
    }, 150);
    return () => clearInterval(id);
  }, [hash, key]);
};

export default function AiotDiploma() {
  const [course, setCourse] = useState(null);
  useHashScroll();
  useEffect(() => {
    document.title = "Advanced AIoT Diploma Course | RoboSpark";
    fetchCourse().then(setCourse).catch(() => setCourse({ demos: [], months: [], classes: [], access: {} }));
  }, []);
  return (
    <div className="bg-white [&_section]:scroll-mt-28" data-testid="aiot-landing">
      <Hero />
      <SubNav />
      <Overview />
      <Highlights />
      <DemoStrip demos={course?.demos} enrolled={course?.access?.enrolled} />
      <Curriculum months={course?.months} classes={course?.classes} enrolled={course?.access?.enrolled} />
      <WeeklyFormat />
      <Assessment />
      <Instructor />
      <Tools />
      <Careers />
      <Faq />
      <ApplySection />
    </div>
  );
}
